module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', [_c('general-main', {
    attrs: {
      "product": _vm.product,
      "identifier": _vm.identifier
    }
  }), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Informações"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Categoria:")]), _vm._v("\n               " + _vm._s(_vm.category.name) + "\n             ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-12@md margin"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('typeCheckout.label')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "badge queue"
  }, [_vm._v(_vm._s(_vm.product.typeCheckout ? 'Sim' : 'Não'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "l-row margin"
  }, [_c('div', {
    staticClass: "l-col-4@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Forma de envio:")]), _vm._v("\n               " + _vm._s(_vm._f("attribute")(_vm.$t(("mercadoLivre.shippingOptions." + (_vm.product.shippingMode) + ".label")))) + "\n             ")])]), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Tipo:")]), _vm._v("\n               " + _vm._s(_vm._f("attribute")(_vm.$t(("mercadoLivre.types." + (_vm.product.type) + ".label")))) + "\n             ")])])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-4@md"
  }, [_c('span', {
    staticClass: "ds-block margin"
  }, [_c('strong', [_vm._v("Condição:")]), _vm._v("\n               " + _vm._s(_vm._f("attribute")(_vm.$t(("mercadoLivre.conditions." + (_vm.product.condition) + ".label")))) + "\n             ")])]), _vm._v(" "), (_vm.product.code) ? _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('span', {
    staticClass: "ds-block margin"
  }, [_c('strong', [_vm._v("Código:")]), _vm._v(" "), (_vm.product.link) ? _c('a', {
    attrs: {
      "href": _vm.product.link,
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "hint hint--bottom",
    attrs: {
      "data-label": "Clique para acessar no marketplace"
    }
  }, [_vm._v(" " + _vm._s(_vm.product.code) + " "), _c('i', {
    staticClass: "icon-new-tab"
  })])]) : _c('span', [_vm._v(_vm._s(_vm.product.code))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "l-col-4@md"
  }, [_c('span', {
    staticClass: "ds-block margin"
  }, [_c('strong', [_vm._v("Data de criação:")]), _vm._v("\n               " + _vm._s(_vm._f("moment")(_vm.product.createdAt, 'DD/MM/YYYY')) + "\n               "), _c('span', {
    staticClass: "hint hint--top",
    attrs: {
      "data-label": "Data de criação ou última migração do anúncio no Placemarket."
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])])])])]), _vm._v(" "), (_vm.productCatalog) ? _c('panel', {
    attrs: {
      "title": "Produto vínculado"
    }
  }, [_c('panel', {
    staticClass: "blue-panel"
  }, [_c('panel', [_c('div', {
    staticClass: "product-catalog"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.productCatalog.pictures[0].url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n                 " + _vm._s(_vm.productCatalog.name) + "\n               ")])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Frete"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    staticClass: "l-col-2@md",
    attrs: {
      "label": "Frete grátis"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.shippingFree),
      expression: "product.shippingFree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.product.shippingFree) ? _vm._i(_vm.product.shippingFree, null) > -1 : (_vm.product.shippingFree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.product.shippingFree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.product, "shippingFree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.product, "shippingFree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.product, "shippingFree", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se o frete do anúncio será grátis.")])]), _vm._v(" "), _c('loader', {
    attrs: {
      "loading": _vm.loadingShippingRules
    }
  }), _vm._v(" "), (_vm.verifyShippingRule(_vm.product.shippingMode) && _vm.product.shippingFree && !_vm.loadingShippingRules) ? _c('div', {
    staticClass: "l-col-8@md"
  }, [_c('strong', [_vm._v("Em caso de frete grátis, escolha a regra:")]), _vm._v(" "), _vm._l((_vm.shippingRules), function(shippingRule) {
    return _c('div', {
      key: shippingRule,
      staticClass: "l-row"
    }, [_c('form-group', {
      attrs: {
        "columns": 4
      }
    }, [_c('radio-button', {
      attrs: {
        "options": _vm.getShippingRuleOptions(shippingRule),
        "checkedDefault": _vm.shippingRuleSelected,
        "toggleChecked": _vm.onChangeShippingRule,
        "name": _vm.announcementConfiguration.identifier
      }
    })], 1), _vm._v(" "), (_vm.shippingRuleSelected === 'exclude_region') ? _c('form-group', {
      attrs: {
        "label": "Regiões não atendidas"
      }
    }, [_c('multiselect', {
      attrs: {
        "options": _vm.regions,
        "selectLabel": "",
        "selectedLabel": "",
        "placeholder": "Escolha",
        "multiple": true
      },
      model: {
        value: (_vm.shippingRuleSelectedRegion),
        callback: function($$v) {
          _vm.shippingRuleSelectedRegion = $$v
        },
        expression: "shippingRuleSelectedRegion"
      }
    })], 1) : _vm._e()], 1)
  })], 2) : _vm._e()], 1)]), _vm._v(" "), (_vm.category.attributes.length) ? _c('panel', {
    attrs: {
      "title": "Atributos"
    }
  }, [_c('general-attributes', {
    attrs: {
      "product": _vm.product,
      "attributes": _vm.category.attributes
    },
    on: {
      "reloadSizes": _vm.setVariationSizes
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fiscal-attributes', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('product-edit-bulk-price', {
    attrs: {
      "product": _vm.product
    }
  }), _vm._v(" "), _c('variation', {
    attrs: {
      "sourceProduct": _vm.sourceProduct,
      "product": _vm.product,
      "category": _vm.category
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e2ad4f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/edit/Product.vue
// module id = 3079
// module chunks = 0